import React from 'react'

function NotFoundPage() {
  return (
    <div className="page-wrap">
      <div className="page-not-found">
        <img
          src="https://res.cloudinary.com/razeshzone/image/upload/v1588316204/house-key_yrqvxv.svg"
          className="img-key"
          alt=""
        ></img>
        <h1 className="text-xl">
          <span>4</span>
          <span>0</span>
          <span className="broken">4</span>
        </h1>
        <h4 className="text-md">Not Found !</h4>
        <h4 className="text-sm text-sm-btm">
          페이지를 찾을 수 없습니다.<a href="#">previous page</a>
        </h4>
      </div>
    </div>
  )
}

export default NotFoundPage
